interface ShowsLoadingOverlayProps {
  label: string;
}

/**
 * Full-viewport loading overlay for any real network/navigation round trip in the booking flow —
 * originally just the Seat Selection Page's "Reserve Tickets" call
 * (`shows-reserve-loading-overlay`), now shared so the SAME visual treatment covers the `LTD.Calendar`
 * "Select" full-page navigation (`LtdCalendarWidget.tsx`) and the Checkout page's "Proceed to
 * Payment" submit (`CheckoutClient.tsx`) too, per explicit request.
 */
export function ShowsLoadingOverlay({ label }: ShowsLoadingOverlayProps) {
  return (
    <div className="shows-loading-overlay" role="status" aria-live="polite" aria-label={label}>
      <div className="shows-loading-spinner" />
    </div>
  );
}
